import ModalComponent from 'components/common/ModalComponent';
import PropTypes from 'prop-types';

const labelClass = 'block text-sm font-medium text-gray-700 mb-2';
const inputClass =
  'w-full p-2 border rounded-md shadow-sm focus:ring-2 focus:ring-greenPrimary focus:border-transparent';

const VarietyModal = ({ isOpen, onClose, onSave, variety, selectedCrop }) => {
  if (!isOpen) return null;

  const isEdit = !!variety;

  const handleSave = formData => {
    if (!formData.name || formData.name.trim() === '') {
      return;
    }
    onSave({
      cropId: selectedCrop.cropId,
      name: formData.name.trim()
    });
  };

  return (
    <ModalComponent
      title={isEdit ? 'Edit Variety' : 'New Variety'}
      isOpen={isOpen}
      onClose={onClose}
      initialData={variety || { name: '' }}
      onSave={handleSave}
    >
      {({ formData, handleChange }) => (
        <form autoComplete="off">
          <div className="space-y-4">
            <div>
              <label className={labelClass}>Crop</label>
              <div className="w-full p-2 bg-gray-50 border border-gray-300 rounded-md text-gray-700">
                {selectedCrop?.name || 'N/A'}
              </div>
            </div>
            <div>
              <label className={labelClass}>Variety Name *</label>
              <input
                type="text"
                name="name"
                value={formData.name || ''}
                onChange={handleChange}
                className={inputClass}
                placeholder="e.g., Cherry, Roma, Beefsteak"
                required
              />
            </div>
          </div>
        </form>
      )}
    </ModalComponent>
  );
};

VarietyModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  variety: PropTypes.object,
  selectedCrop: PropTypes.object
};

export default VarietyModal;
